import { Show } from "solid-js";

/** Standard rendering for an `AsyncAction`'s error message; empty renders nothing. */
export function FormError(props: { message: string; class?: string }) {
  return (
    <Show when={props.message}>
      <div class={props.class ?? "gate-error"}>{props.message}</div>
    </Show>
  );
}
